const User = () => {
  return (
    <div>
      user loarde
    </div>
  )
}

export default User
